import { useBreakpoints } from '../../bookings/util/useBreakpoints';
import {
  TrackingDataEvent,
  TrackingDataLocation,
} from '../../common/AnalyticsContext/LinkTracking';
import { renderLinkTrackingAttributes } from '../../common/AnalyticsContext/renderLinkTrackingAttributes';
import { SearchPromotionItem } from '../../common/components/SearchHeader/Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';
import { IconGPMobile } from '../../common/components/icons/IconGPMobile';
import { IconInPerson } from '../../common/components/icons/IconInPerson';
import { IconTelehealth } from '../../common/components/icons/IconTelehealth';
import { useRouter } from '../../common/hooks/useRouter';
import { addQueryParams } from '../../common/routing/addQueryParams';
import { StyledGPCard, StyledGPCardContainer } from './GPHomepageCard.styles';

export enum GPButtonTypes {
  GP = 0,
  Telehealth = 1,
}

export const translateTypeToButtonProps = (type: GPButtonTypes, isMobile: boolean) => {
  switch (type) {
    case GPButtonTypes.Telehealth:
      return {
        title: 'GP Telehealth',
        subtitle: 'Form, phone and video consults',
        icon: <IconTelehealth />,
        analyticLabel: 'General Practice Telehealth',
      };
    case GPButtonTypes.GP:
      return {
        title: 'GP In-Person',
        subtitle: isMobile
          ? 'Book a health provider to see in-person'
          : 'Book a doctor to see in-person',
        icon: isMobile ? <IconGPMobile /> : <IconInPerson />,
        analyticLabel: 'General Practice',
      };
  }
};

export interface Props {
  type: GPButtonTypes;
  onSelectSpecialty?: (specialty: SearchPromotionItem | null, i: number) => void;
  specialty: SearchPromotionItem;
  active?: boolean;
  analyticLabel?: string;
}

export const GPHomepageCard = ({ type, onSelectSpecialty, specialty, active }: Props) => {
  const isMobile = useBreakpoints().Small;
  const buttonProps = translateTypeToButtonProps(type, isMobile);
  const router = useRouter();

  const redirectToTelehealthServicesPage = () => {
    const url = addQueryParams(`https://services.healthengine.com.au/telehealth-gp-options`, {
      source: 'hp',
    });

    void router?.push(url);
  };

  const buttonOnClick = () => {
    switch (type) {
      case GPButtonTypes.Telehealth:
        onSelectSpecialty?.(specialty, GPButtonTypes.Telehealth);
        redirectToTelehealthServicesPage();
        break;
      case GPButtonTypes.GP:
        onSelectSpecialty?.(specialty, GPButtonTypes.GP);
    }
  };

  return (
    <StyledGPCardContainer role="button">
      <StyledGPCard
        onClick={buttonOnClick}
        active={active}
        type={type}
        {...renderLinkTrackingAttributes({
          event: TrackingDataEvent.SEARCH_BOX_SELECTOR_OPTION_CLICK,
          location: TrackingDataLocation.HOMEPAGE_HERO,
          specialty: buttonProps.analyticLabel,
        })}
        {...buttonProps}
      />
    </StyledGPCardContainer>
  );
};
